<template>
  <div>
    <div class="w-full cont">
      <sy></sy>
    </div>
    <div class="w-full cont">
      <div class="warnmsg" style="text-align: center;
      font-size:13px;font-weight:bold;
          padding: 30px;">
          <versionReminder></versionReminder>
        </div>
    </div>
    <div class="w-full footer-bg" style="height: 140px;padding-top: 28px;">
      <div class="f_14" style="width:78%;margin:0 auto;">
        <div class="demo" flex="main:justify">
          <div style="display: flex; align-items: center">
            <div v-if="footlogo"><img :src="footlogo" height="77"/></div>
            <!--<div v-else style="float: left;"><img src="../../assets/images/f_logo.png" height="77" width="86"/></div>-->
            <div style="padding-left: 15px;line-height: 24px;">
              <div>热线电话：{{sysparam.hottel ? sysparam.hottel.sysparambeg : ''}}</div>
              <div>Email：{{sysparam.email ? sysparam.email.sysparambeg : ''}}</div>
              <div>地址：{{sysparam.address ? sysparam.address.sysparambeg : ''}}</div>
            </div>
          </div>
          <div class="right" style="padding-top: 20px;">
            <div style="display: flex; align-items: center">
              <div v-if="qrimg"><img :src="qrimg" height="77"/></div>
              <div style="padding-left: 15px;line-height: 24px;">
                <div><span @click="link">{{sysparam.webcode ? sysparam.webcode.sysparambeg : ''}}</span></div>
                <div>版权所有：{{sysparam.copyright ? sysparam.copyright.sysparambeg : ''}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Sy from './Sy.vue'
  import {mapState} from 'vuex'
  import versionReminder from '../common/versionReminder'

  export default {
    data () {
      return {}
    },
    methods: {
      link () {
        if (this.sysparam.webcode.sysparamend) {
          window.open(this.sysparam.webcode.sysparamend)
        }
      },
      linkSelf (val) {
        window.location.href = val
      }
    },
    components: {Sy, versionReminder},
    computed: {
      ...mapState({
        sysparam: state => state.sysparam,
        picAddr: state => state.picAddr
      }),
      footlogo () {
        if (this.sysparam.footlogo && this.sysparam.footlogo.sysparambeg) {
          let index = this.sysparam.footlogo.sysparambeg.indexOf('upload/')
          if (index > -1) {
            return this.sysparam.footlogo ? this.picAddr + this.sysparam.footlogo.sysparambeg : ''
          }
        }
      },
      qrimg () {
        if (this.sysparam.qrimg && this.sysparam.qrimg.sysparambeg) {
          let index = this.sysparam.qrimg.sysparambeg.indexOf('upload/')
          if (index > -1) {
            return this.sysparam.qrimg ? this.picAddr + this.sysparam.qrimg.sysparambeg : ''
          }
        }
      }
    }
  }
</script>
<style scoped>
  span {
    color: #fff;
  }

  .cont {
    background: #fff;
    border-top: 1px solid #ddd;
  }

  .right {
    padding-top: 10px;
    line-height: 24px;
  }

  .right span {
    cursor: pointer;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// WebFooter.vue?8fe98caa